/**
 * What a press of Snap or Hurry does (slice 11c, play first). The player always picks the play:
 * a call starts with none, and Snap with none opens the Book on Plays instead of snapping. Hurry
 * is the no-huddle: it keeps the player's last play on offense (`lastPlay`, cleared on a change of
 * possession by the session), and opens the Book on Plays only when there is none. Whatever goes
 * to the session carries a play, so the action row can never send a call without one.
 */
import { hasPlay, type Draft } from './draft';

export type RowPress = 'snap' | 'hurry';

/** A draft with its play picked. */
export type PlayedDraft = Draft & { playId: string };

export type RowAction =
  | { kind: 'snap'; draft: PlayedDraft }
  | { kind: 'hurry'; draft: PlayedDraft }
  | { kind: 'book'; tab: 'plays' };

export function rowAction(press: RowPress, draft: Draft, lastPlay: string | null): RowAction {
  if (press === 'snap')
    return hasPlay(draft) ? { kind: 'snap', draft } : { kind: 'book', tab: 'plays' };
  const playId = draft.playId ?? lastPlay;
  return playId === null
    ? { kind: 'book', tab: 'plays' }
    : { kind: 'hurry', draft: { ...draft, playId } };
}
